import { Pipe, PipeTransform } from '@angular/core';
import { AccountType } from '@shared/enums';
import { Module } from '@shared/models';

@Pipe({
  name: 'moduleHasClientAccess',
})
export class ModuleHasClientAccessPipe implements PipeTransform {
  transform(
    module: Module,
    accountType: AccountType,
    clientModules: string[]
  ): boolean {
    return (
      accountType === AccountType.SystemAdmin ||
      clientModules?.includes(module.id)
    );
  }
}
